import {DynamicParametersType} from '../dynamicParameters/dynamicParameters.enums';
import {TaxonomyDataType, TaxonomyType} from './taxonomy.enums';

const taxonomyDataTypeLabels: Record<TaxonomyDataType, string> = {
  [TaxonomyDataType.Image]: 'Image',
  [TaxonomyDataType.ImageList]: 'Image List',
  [TaxonomyDataType.Video]: 'Video',
  [TaxonomyDataType.Text]: 'Text',
  [TaxonomyDataType.TextList]: 'Text List',
  [TaxonomyDataType.Number]: 'Number',
  [TaxonomyDataType.Color]: 'Color',
  [TaxonomyDataType.PageURL]: 'Page URL',
  [TaxonomyDataType.Date]: 'Date',
  [TaxonomyDataType.DateList]: 'Date List',
  [TaxonomyDataType.DateTime]: 'Date Time',
  [TaxonomyDataType.Condition]: 'Condition',
  [TaxonomyDataType.Font]: 'Font',
  [TaxonomyDataType.Subtitles]: 'Subtitles',
  [TaxonomyDataType.Audio]: 'Audio',
};

const taxonomyDataTypeToDynamicParametersType: Record<TaxonomyDataType, DynamicParametersType> = {
  [TaxonomyDataType.Image]: DynamicParametersType.Image,
  [TaxonomyDataType.ImageList]: DynamicParametersType.Image,
  [TaxonomyDataType.Video]: DynamicParametersType.Video,
  [TaxonomyDataType.Text]: DynamicParametersType.Text,
  [TaxonomyDataType.TextList]: DynamicParametersType.Text,
  [TaxonomyDataType.Number]: DynamicParametersType.FloatNumber,
  [TaxonomyDataType.Color]: DynamicParametersType.Color,
  [TaxonomyDataType.PageURL]: DynamicParametersType.Link,
  [TaxonomyDataType.Date]: DynamicParametersType.Text,
  [TaxonomyDataType.DateList]: DynamicParametersType.Text,
  [TaxonomyDataType.DateTime]: DynamicParametersType.Text,
  [TaxonomyDataType.Condition]: DynamicParametersType.Boolean,
  [TaxonomyDataType.Font]: DynamicParametersType.Font,
  [TaxonomyDataType.Subtitles]: DynamicParametersType.Subtitles,
  [TaxonomyDataType.Audio]: DynamicParametersType.Audio,
};

const taxonomyTypeToName: Record<TaxonomyType, string> = {
  [TaxonomyType.Location]: 'Location',
  [TaxonomyType.Content]: 'Content',
  [TaxonomyType.Metric]: 'Metric',
  [TaxonomyType.FirstParty]: '1st Party Data',
  [TaxonomyType.Product]: 'Ecommerce',
};

export {taxonomyDataTypeLabels, taxonomyDataTypeToDynamicParametersType, taxonomyTypeToName};
